import React from 'react'

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { Pie } from 'react-chartjs-2'

import { ChartStyle, ChartTitle, Container, DashStyles, FilterStyles } from './styles'
import useIsMobile from '../../../hooks/useIsMobile'
import { useForm } from 'react-hook-form'
import SelectInput from '../../../components/Input/SelectInput'
import { ContentCenter, Form } from '../../../components/commons'
import DateRangeInput from '../../../components/Input/DateRangeInput'
import useUsers from '../../../services/users.service'
import useDocuments from '../../../services/documents.service'
import Button from '../../../components/Button'
import { api } from '../../../services/api'
import { useTheme } from 'styled-components'
import { useNavigate } from 'react-router-dom'

ChartJS.register(ArcElement, Tooltip, Legend)

export interface HomeProps {}

const FoldersList = ({ control }: { control: any }) => {
  const [search, setSearch] = React.useState<string>()

  const { isLoading, data, refetch } = useDocuments(1, 18, search, undefined, [], {
    isFolder: true,
  })

  return (
    <>
      <SelectInput
        control={control}
        onChangeText={(search) => setSearch(search)}
        options={data?.data.map((document) => ({
          label: document?.name,
          value: document?._id,
        }))}
        isLoading={isLoading}
        placeholder='Selecionar Pastas'
        isMulti
        gray
        name={'folders'}
      />
    </>
  )
}

export const UsersList = ({
  control,
  label,
  isMulti,
  onSelect,
}: {
  control: any
  label?: string
  isMulti?: Boolean
  onSelect?: (item: any) => void
}) => {
  const [search, setSearch] = React.useState<string>()

  const { isLoading, data, refetch } = useUsers(1, 18, search, undefined)

  return (
    <>
      <SelectInput
        control={control}
        onChangeText={(search) => setSearch(search)}
        options={data?.data.map((user) => ({
          label: user?.name,
          value: user?._id,
        }))}
        onSelect={onSelect}
        label={label}
        placeholder='Selecionar Usuarios'
        isMulti={!!isMulti}
        gray
        isLoading={isLoading}
        name={'users'}
      />
    </>
  )
}

interface FiltersInterface {
  date: string
  documentType: any
  accessLevel: any
  folders: any
  users: any
}

interface ChatInterface {
  title: string
  total?: number
  filter?: number
}

const Filters = ({
  handleGetStatistics,
}: {
  handleGetStatistics: (date: any, accessLevel: any, users: any, folders: any) => void
}) => {
  const {
    control,
    reset,
    watch,
    formState: { errors },
  } = useForm<FiltersInterface>()

  const date: any = watch('date')
  const accessLevel: any = watch('accessLevel')
  const users: any = watch('users')
  const folders: any = watch('folders')

  React.useEffect(() => {
    handleGetStatistics(date, accessLevel, users, folders)
  }, [date, accessLevel, users, folders])

  return (
    <FilterStyles.Content>
      <FilterStyles.Title>Filtros</FilterStyles.Title>
      <Form>
        <DateRangeInput
          control={control}
          name={'date'}
          gray
          error={errors.date}
          placeholder='Filtrar por Data'
        />
        <SelectInput
          control={control}
          isMulti
          gray
          placeholder='Tipo de documento'
          options={[
            {
              value: 'all-access',
              label: 'Acesso Total',
            },
            {
              value: 'visualizer',
              label: 'Visualizador',
            },
            {
              value: 'editor',
              label: 'Editor',
            },
          ]}
          name={'accessLevel'}
        />
        <FoldersList control={control} />
        <UsersList control={control} />

        <ContentCenter>
          <Button
            label='Limpar'
            onClick={() => {
              reset()
            }}
            color='primary'
            variantType='small'
          />
        </ContentCenter>
      </Form>
    </FilterStyles.Content>
  )
}

const Chart = ({ title, total = 0, filter = 0 }: ChatInterface) => {
  const theme: any = useTheme()
  const data = {
    labels: ['Total', 'Filtros (bytes)'],

    datasets: [
      {
        label: '',
        data: [0, 0],
        backgroundColor: [theme.colors.primary, theme.colors.secondary],
        borderColor: [theme.colors.secondary, theme.colors.primary],
        borderWidth: 1,
      },
    ],
  }

  data.datasets[0].data = [total, filter]

  return (
    <ChartStyle.Content>
      <div style={{ padding: 10, maxWidth: 250, margin: 'auto' }}>
        <ChartTitle>{title}</ChartTitle>
        <Pie data={data} />
      </div>
    </ChartStyle.Content>
  )
}

const Home: React.FunctionComponent<HomeProps> = () => {
  const mobile = useIsMobile()

  const nav = useNavigate()
  const [statistics, setstatistics] = React.useState<any>()

  const handleGetStatistics = async (date: any, accessLevel: any, users: any, folders: any) => {
    try {
      const { data: response } = await api.get(`/dashboard/statistics`, {
        params: {
          dateStart: date?.startDate,
          dateEnd: date?.endDate,
          accessLevel: JSON.stringify(accessLevel?.map((access: any) => access.value)),
          users: JSON.stringify(users?.map((user: any) => user.value)),
          folders: JSON.stringify(folders?.map((fold: any) => fold.value)),
        },
      })

      setstatistics(response)
    } catch (error) {
      nav('/documents')
    }
  }

  return (
    <Container>
      <DashStyles.RightPanel hidden={!mobile}>
        <Filters handleGetStatistics={handleGetStatistics} />
      </DashStyles.RightPanel>
      <DashStyles.LeftPanel>
        <Chart
          title={'Documentos'}
          total={statistics?.documentsTotal}
          filter={statistics?.documentsFilter}
        />
        <Chart title={'Volume'} total={statistics?.sizeTotal} filter={statistics?.sizeFilter} />
      </DashStyles.LeftPanel>
      <DashStyles.RightPanel hidden={mobile}>
        <Filters handleGetStatistics={handleGetStatistics} />
      </DashStyles.RightPanel>
    </Container>
  )
}

export default Home
